let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kwWW2")).then(() => parcelRequire('9GdMy'));